import {
    PlayerDetailsResponse,
    VideoPlayer
} from "@switcherstudio/switcher-api-client";
import { updateKey } from "../objects";

export const mapPlayerDetailsResponseResponseToVideoPlayer = (
    input: PlayerDetailsResponse
): VideoPlayer => {
    return updateKey(
        input,
        "IdleState",
        "PlayerDetailsResponseIdleState"
    ) as unknown as VideoPlayer;
};
